var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4141 0.398438H3.32812C1.69531 0.398438 0.375 1.6875 0.375 3.28125V37.5078C0.375 39.1016 1.69531 40.3984 3.32812 40.3984H37.4141C39.0469 40.3984 40.375 39.1016 40.375 37.5156V3.28125C40.375 1.6875 39.0469 0.398438 37.4141 0.398438ZM12.2422 34.4844H6.30469V15.3906H12.2422V34.4844ZM9.27344 12.7891C7.36719 12.7891 5.82812 11.25 5.82812 9.35156C5.82812 7.45312 7.36719 5.91406 9.27344 5.91406C11.1719 5.91406 12.7109 7.45312 12.7109 9.35156C12.7109 11.2422 11.1719 12.7891 9.27344 12.7891ZM34.4609 34.4844H28.5312V25.2031C28.5312 22.9922 28.4922 20.1406 25.4453 20.1406C22.3594 20.1406 21.8906 22.5547 21.8906 25.0469V34.4844H15.9688V15.3906H21.6562V18H21.7344C22.5234 16.5 24.4609 14.9141 27.3438 14.9141C33.3516 14.9141 34.4609 18.8672 34.4609 24.0078V34.4844Z",
    fill: "#FFF9EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.fedd605c3aa14878dc2355d5de14e86a.svg";
export { ForwardRef as ReactComponent };